import { Collapse } from '@material-ui/core';

import LedgerRow from './financial.ledger.component';
import utilsProvider from '../../providers/utils.provider';

const REVIEWER_LABEL = 'Revisor';

const FACILITER_LABEL = 'Faciliter';

const roleOf = (link) => link.isReviewer ? REVIEWER_LABEL : FACILITER_LABEL;

const titleOf = (link) => link.serviceName || link.label;

const UNLINKED_CLASS = 'ml-2 rounded bg-[#f2f2f2] px-1.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-gray-500';

const nameOf = (link) => ['·', roleOf(link), link.responsibleName].filter(Boolean).join(' ');

const hintOf = (link) => (
    <>
        {nameOf(link)}
        {link.isUnlinked ? <span className={UNLINKED_CLASS}>desfeito</span> : null}
    </>
);

const DETAIL_ANIMATION_MS = 220;

const totalOf = (links) => links.reduce(
    (total, link) => total + (parseFloat(link.amount) || 0) + (parseFloat(link.otherInvoiceAmount) || 0), 0);

const otherInvoiceLabel = (link) => `Lançado na fatura de ${link.otherInvoiceMonths}`;

const NESTED_CLASS = 'mb-1 ml-1 border-l-2 border-[#ececee] pb-1 pl-4';

const OtherInvoiceLine = ({ link }) => (
    <div className={NESTED_CLASS}>
        <LedgerRow
            label={otherInvoiceLabel(link)}
            value={utilsProvider.formatNumberCurrency(link.otherInvoiceAmount)}
            isNegative={Number(link.otherInvoiceAmount) < 0}
        />
    </div>
);

const FaciliterDetail = ({ link, onRemoveDiscount }) => (
    <div className={NESTED_CLASS}>
        {(link.priceFees || []).map((fee, index) => (
            <LedgerRow
                key={[fee.label, index].join('-')}
                label={fee.label}
                value={utilsProvider.formatNumberCurrency(fee.price)}
                isNegative={Number(fee.price) < 0}
                isSecondary
            />
        ))}

        {link.isPriceDiscounted && (
            <button type="button" onClick={() => onRemoveDiscount(link)} className="mt-1 text-xs text-[#376fd0] underline">
                remover desconto
            </button>
        )}
    </div>
);

const FaciliterLine = ({ link, isDetailed, onRemoveDiscount }) => (
    <div>
        <LedgerRow
            label={titleOf(link)}
            hint={hintOf(link)}
            value={utilsProvider.formatNumberCurrency(link.amount)}
            isNegative={Number(link.amount) < 0}
        />

        <Collapse in={isDetailed} timeout={DETAIL_ANIMATION_MS} unmountOnExit>
            <FaciliterDetail link={link} onRemoveDiscount={onRemoveDiscount} />
        </Collapse>

        {link.otherInvoiceAmount ? <OtherInvoiceLine link={link} /> : null}

        {link.tipValue ? (
            <LedgerRow label="Gorjeta" value={utilsProvider.formatNumberCurrency(link.tipValue)} />
        ) : null}
    </div>
);

export default function FinancialFaciliterSection({ links, isDetailed, onRemoveDiscount }) {
    return (
        <>
            {links.map((link, index) => (
                <FaciliterLine
                    key={[link.responsibleId, index].join('-')}
                    link={link}
                    isDetailed={isDetailed}
                    onRemoveDiscount={onRemoveDiscount}
                />
            ))}

            <LedgerRow
                label="Total"
                value={utilsProvider.formatNumberCurrency(totalOf(links))}
                isTotal
                isNegative={totalOf(links) < 0}
            />
        </>
    );
}
